<template>
  <div>
    <Header></Header>

    <!-- PAGE HEADER -->
    <div class="page-header seja-editor">
      <div class="container">
        <div class="row">
          <div class="col-md-offset-1 col-md-10 text-center">
            <h1 class="text-uppercase">Seja um Editor</h1>
          </div>
        </div>
      </div>
    </div>
    <!-- /PAGE HEADER -->

    <!-- SECTION -->
    <div class="section">
      <!-- container -->
      <div class="container">
        <!-- row -->
        <div class="row">
          <div class="col-md-12">
            <div class="section-row">
              <div class="section-title">
                <h2 class="title">
                  Bem-vindo(a) à área de editores do Portal Pedline
                </h2>
              </div>
              <p>
                <b
                  >Você é um profissional da saúde e quer escrever para o nosso
                  portal?</b
                >
              </p>
              <p>
                Antes de se tornar um colaborador do nosso site, você precisa
                saber que:
              </p>
              <ul style="list-style:initial;">
                <li>
                  Você precisa ser um profissional com registro comprovado da
                  sua área (médico, nutricionista, fisioterapeuta, psicólogo,
                  etc);
                </li>
                <li>Os artigos precisam ter embasamento científico;</li>
                <li>
                  Os artigos não podem ter cunho comercial, nem indicação de
                  medicamentos, exames, etc;
                </li>
                <li>Sua colaboração é voluntária;</li>
                <li>
                  Seus artigos serão assinados por você e o conteúdo deles é de
                  sua total responsabilidade;
                </li>
                <li>
                  Não será divulgado nenhum contato seu (telefone, redes
                  sociais, endereço, sites...);
                </li>
                <li>
                  Antes da publicação, todos os artigos são previamente
                  avaliados por nossa equipe.
                </li>
              </ul>

              <div
                @click="showSignUpForm"
                class="primary-button btn-editor pointer"
              >
                Quero me tornar um editor
              </div>

              <transition enter-active-class="animated fadeIn">
                <div id="signUpForm" v-show="showForm" class="row mt-1">
                  <h2 class="title form-title" style="padding-left:15px;">
                    Por favor, preencha o formulário abaixo.
                  </h2>

                  <div class="col-md-12">
                    <div class="form-group">
                      <input
                        class="input"
                        v-model="editor.name"
                        type="text"
                        placeholder="Nome Completo *"
                      />
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <input
                        class="input"
                        v-model="editor.email"
                        type="email"
                        placeholder="E-mail *"
                      />
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <input
                        class="input"
                        v-model="editor.mobileNumber"
                        type="text"
                        placeholder="Telefone para contato *"
                      />
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group file">
                      Registro de Conselho da sua Categoria *
                      <input
                        @change="setJobDocument"
                        class="input"
                        id="jobDocument"
                        type="file"
                      />
                      <span class="file-formats"
                        >Formatos: .pdf, .jpeg, .png</span
                      >
                      <transition enter-active-class="animated fadeIn">
                        <div v-show="editor.jobDocument" class="check">✔</div>
                      </transition>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="form-group file">
                      Currículo *
                      <input
                        @change="setCurriculum"
                        class="input"
                        id="curriculum"
                        type="file"
                      />
                      <span class="file-formats"
                        >Formatos: .pdf, .jpeg, .png</span
                      >
                      <transition enter-active-class="animated fadeIn">
                        <div v-show="editor.curriculum" class="check">✔</div>
                      </transition>
                    </div>
                  </div>

                  <div
                    v-show="editor.jobDocument && editor.curriculum"
                    class="col-md-12"
                  >
                    <div class="form-group">
                      <input
                        class="input"
                        @blur="getCep()"
                        v-model="editor.zipcode"
                        type="text"
                        placeholder="CEP *"
                      />
                    </div>
                  </div>

                  <transition enter-active-class="animated fadeIn">
                    <div v-show="showFullAddress">
                      <div class="col-md-12">
                        <div class="form-group">
                          <input
                            class="input"
                            v-model="editor.uf"
                            type="text"
                            placeholder="UF *"
                          />
                        </div>
                      </div>

                      <div class="col-md-12">
                        <div class="form-group">
                          <input
                            class="input"
                            v-model="editor.city"
                            type="text"
                            placeholder="Cidade *"
                          />
                        </div>
                      </div>

                      <div class="col-md-12">
                        <div class="form-group">
                          <input
                            class="input"
                            v-model="editor.neighborhood"
                            type="text"
                            placeholder="Bairro *"
                          />
                        </div>
                      </div>

                      <div class="col-md-12">
                        <div class="form-group">
                          <input
                            class="input"
                            v-model="editor.address"
                            type="text"
                            placeholder="Endereço *"
                          />
                        </div>
                      </div>

                      <div class="col-md-12">
                        <div class="form-group">
                          <input
                            class="input"
                            v-model="editor.number"
                            type="text"
                            placeholder="Número *"
                          />
                        </div>
                      </div>

                      <div class="col-md-12">
                        <div class="form-group">
                          <input
                            class="input"
                            v-model="editor.complement"
                            type="text"
                            placeholder="Complemento"
                          />
                        </div>
                      </div>
                    </div>
                  </transition>

                  <div v-show="showFullAddress" class="col-md-12">
                    <div class="form-group">
                      <input
                        class="input"
                        v-model="editor.jobTitle"
                        type="text"
                        placeholder="Profissão *"
                      />
                    </div>
                  </div>

                  <div v-show="showFullAddress" class="col-md-12">
                    <div class="form-group">
                      <input
                        class="input"
                        v-model="editor.specialty"
                        type="text"
                        placeholder="Especialidade"
                      />
                    </div>
                  </div>

                  <div v-show="showFullAddress" class="col-md-12">
                    <div class="form-group">
                      <input
                        class="input"
                        v-model="editor.workPlace"
                        type="text"
                        placeholder="Local de trabalho atual *"
                      />
                    </div>
                  </div>

                  <div v-show="showFullAddress" class="col-md-12">
                    <div class="form-group">
                      <input
                        class="input"
                        v-model="editor.password"
                        type="password"
                        placeholder="Crie sua senha *"
                      />
                    </div>
                  </div>

                  <div v-show="showFullAddress" class="col-md-12">
                    <div class="form-group">
                      <input
                        class="input"
                        v-model="editor.password2"
                        type="password"
                        placeholder="Confirmar senha *"
                      />
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div v-show="formSent" class="form-group">
                      <p style="color:#29b715;">
                        Recebemos o seu cadastro. Obrigado pelo interesse em
                        ajudar! Iremos analisar e entrar em contato com você o
                        mais rápido o possível.
                      </p>
                    </div>

                    <transition enter-active-class="animated fadeIn">
                      <p style="color:#f00;" v-show="warningMessage != ''">
                        {{ warningMessage }}
                      </p>
                    </transition>

                    <button @click="signUp" class="primary-button">
                      <div v-show="!loading">CADASTRAR</div>
                      <div v-show="loading" class="loading-spinner"></div>
                    </button>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </div>
        <!-- /row -->
      </div>
      <!-- /container -->
    </div>
    <!-- /SECTION -->

    <Footer></Footer>
  </div>
</template>
<script>
import http from "@/http";
import Header from "../components/Header";
import Footer from "../components/Footer";
import validators from "../util/validators";

export default {
  name: "SejaEditor",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      showForm: false,
      formSent: false,
      showFullAddress: false,
      warningMessage: "",
      loading: false,
      editor: {
        name: "",
        email: "",
        jobTitle: "",
        mobileNumber: "",
        workPlace: "",
        specialty: "",
        zipcode: "",
        uf: "",
        city: "",
        neighborhood: "",
        address: "",
        number: "",
        complement: "",
        password: "",
        password2: "",
        jobDocument: "",
        curriculum: "",
        facebook: "",
        linkedin: "",
        instagram: "",
        twitter: "",
        image: ""
      }
    };
  },
  methods: {
    showSignUpForm() {
      this.showForm = true;
      setTimeout(() => {
        let distance =
          document.getElementById("signUpForm").offsetHeight +
          document.getElementById("signUpForm").offsetTop -
          110;
        window.scroll({
          top: distance,
          left: 0,
          behavior: "smooth"
        });
      }, 100);
    },
    setJobDocument(event) {
      let file = event.target.files[0];
      if (
        file.type === "application/pdf" ||
        file.type === "image/png" ||
        file.type === "image/jpeg" ||
        file.type === "image/jpg"
      ) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = event => {
          this.editor.jobDocument = event.target.result;
        };
      } else {
        this.warningMessage = "Formato de arquivo não suportado";
        this.editor.jobDocument = "";
      }
    },
    setCurriculum(event) {
      let file = event.target.files[0];
      if (
        file.type === "application/pdf" ||
        file.type === "image/png" ||
        file.type === "image/jpeg" ||
        file.type === "image/jpg"
      ) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = event => {
          this.editor.curriculum = event.target.result;
        };
      } else {
        this.warningMessage = "Formato de arquivo não suportado";
        this.editor.curriculum = "";
      }
    },
    signUp() {
      if (this.editor.name == "") {
        this.warningMessage = "Por favor, informe o seu nome.";
        return;
      }
      if (this.editor.email == "") {
        this.warningMessage = "Por favor, informe o seu e-mail.";
        return;
      }
      if (!validators.validateEmail(this.editor.email)) {
        this.warningMessage = "Por favor, informe um e-mail válido.";
        return;
      }
      if (!this.editor.mobileNumber) {
        this.warningMessage = "Por favor, informe um número para contato.";
        return;
      }
      if (!this.editor.jobDocument) {
        this.warningMessage =
          "Por favor, anexe seu registro de Conselho da sua Categoria.";
        return;
      }
      if (!this.editor.curriculum) {
        this.warningMessage = "Por favor, anexe o seu currículo.";
        return;
      }
      if (this.editor.zipcode.length != 8) {
        this.warningMessage = "Por favor, informe um cep válido";
        return;
      }
      if (this.editor.uf == "") {
        this.warningMessage = "Por favor, informe o seu estado.";
        return;
      }
      if (this.editor.city == "") {
        this.warningMessage = "Por favor, informe a sua cidade.";
        return;
      }
      if (this.editor.neighborhood == "") {
        this.warningMessage = "Por favor, informe o seu bairro.";
        return;
      }
      if (this.editor.address == "") {
        this.warningMessage = "Por favor, informe o seu endereço.";
        return;
      }
      if (this.editor.number == "") {
        this.warningMessage = "Por favor, informe o seu número.";
        return;
      }
      if (this.editor.jobTitle == "") {
        this.warningMessage = "Por favor, informe a sua profissão.";
        return;
      }
      if (this.editor.workPlace == "") {
        this.warningMessage =
          "Por favor, informe o seu local de trabalho atual.";
        return;
      }
      if (this.editor.password.length < 6) {
        this.warningMessage =
          "Por favor, informe uma senha com pelo menos 6 caracteres.";
        return;
      }
      if (!this.editor.password2) {
        this.warningMessage = "Por favor, confirme a sua senha.";
        return;
      }
      if (this.editor.password !== this.editor.password2) {
        this.warningMessage =
          "Sua senha e verificação de senha não estão iguais. Por favor, verifique e tente novamente.";
        return;
      }

      this.warningMessage = "";
      this.loading = true;

      http
        .post("user", this.editor)
        .then(() => {
          this.formSent = true;
        })
        .catch(err => {
          console.error(err);
          this.warningMessage =
            "Algo deu errado, por favor tente novamente em alguns instantes.";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCep() {
      this.editor.zipcode = this.editor.zipcode
        ? this.editor.zipcode.replace(/[^\d]/g, "")
        : "--";

      if (this.editor.zipcode.length != 8) {
        this.warningMessage = "Por favor, informe um cep válido";
        return;
      } else {
        http
          .get(`https://viacep.com.br/ws/${this.editor.zipcode}/json/`)
          .then(response => {
            this.editor.uf = response.data.uf;
            this.editor.city = response.data.localidade;
            this.editor.neighborhood = response.data.bairro;
            this.editor.address = response.data.logradouro;
          })
          .catch(err => {
            console.log(err);
          })
          .finally(() => {
            this.showFullAddress = true;
          });
      }
    }
  }
};
</script>
<style scoped>
.form-title {
  font-size: 1.2em;
  color: #505050;
}

.form-group {
  position: relative;
  max-width: 460px;
}

.form-group.file {
  border: none !important;
  border-bottom: 1px solid #ddd !important;
}

.form-group.file input[type="file"] {
  border: none !important;
  margin-top: 10px !important;
  padding-left: 0 !important;
  outline: none;
}

.file-formats {
  position: relative;
  display: block;
  margin: -12px 0 0 0;
  color: var(--secondary);
}

.form-group.file .check {
  position: absolute;
  right: 0;
  bottom: 0;
  font-size: 1.2em;
  color: rgb(28, 212, 37);
}
</style>



// WEBPACK FOOTER //
// src/views/SejaEditor.vue